import React from 'react';
import { Navigate } from 'react-router-dom';
import { checkComponentPermission, isLoggedIn } from './utils/share';
import Page404 from './pages/Page404';

// eslint-disable-next-line react/display-name
export const WithAuth = (Component, permission, isProtected) => (props) => {
  const isAuthenticated = isLoggedIn();
  if (isProtected && !isAuthenticated) {
    return <Navigate to={'/auth/login'} />;
  }

  if (permission && !checkComponentPermission(permission)) {
    return <Page404 />;
  }

  return <Component {...props} />;
};
